export const GLOBAL_STATE = 'Calendar'

export const CALENDAR_EVENT = 'CALENDAR_EVENT' as const
export const CALENDAR_EVENT_CREATE = 'CALENDAR_EVENT_CREATE' as const
export const CALENDAR_EVENT_DELETE = 'CALENDAR_EVENT_DELETE' as const
export const CALENDAR_EVENT_LIST = 'CALENDAR_EVENT_LIST' as const
export const CALENDAR_EVENT_LIST_STUDENT = 'CALENDAR_EVENT_LIST_STUDENT' as const
export const CALENDAR_EVENT_ALL = 'CALENDAR_EVENT_ALL' as const
export const CALENDAR_EVENT_TEACHING_WEEKS = 'CALENDAR_EVENT_TEACHING_WEEKS' as const
